import styled from 'styled-components';
import theme from 'styles/theme';

export const DataListWrapper = styled.ul`
  li {
    position: relative;
    margin-left: 0;
    list-style: none;
    background-color: #f5f5f5;
    border-radius: 5px;
    padding: 15px 10px 20px;

    & + li {
      margin-top: 22px;
    }

    label {
      display: inline-block;
      height: 22px;
      padding: 0 8px;
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      border-radius: 5px;
      line-height: 24px;

      &.FAIL {
        background: rgba(252, 85, 85, 0.15);
        color: #fc5555;
      }
      &.WAIT {
        background: rgba(41, 204, 106, 0.15);
        color: ${theme.color.lightGreen};
      }
      &.STOP {
        background: rgba(255, 86, 8, 0.15);
        color: #ff5608;
      }
      &.FINISH {
        background: rgba(0, 159, 249, 0.15);
        color: ${theme.color.blue};
      }
      &.UNAVAILABLE {
        background: rgba(17, 17, 17, 0.15);
        color: ${theme.color.black};
      }
    }

    .buttonGroup {
      position: absolute;
      top: 15px;
      right: 15px;

      button {
        height: 23px;
        line-height: 23px;
        font-size: 14px;
        font-weight: 500;
        color: ${theme.color.buttonLink};
        -webkit-tap-highlight-color: transparent;

        &:disabled {
          color: ${theme.color.policyGrey};
          pointer-events: none;
        }

        & + button {
          &::before {
            content: '|';
            display: inline-block;
            margin: 0 6px;
          }
        }
      }
    }

    dl {
      margin-top: 15px;
      padding-left: 3px;
      font-size: 13px;
      line-height: 22px;

      dt {
        font-weight: 700;
      }
    }

    .failMessageBox {
      position: relative;
      margin-top: 15px;
      padding: 13px 12px;
      text-align: start;
      border-radius: 5px;
      background-color: #fff;

      .title {
        margin-right: 22px;
        font-size: 12px;
        line-height: 12px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        img {
          width: 14px;
          height: 14px;
          vertical-align: bottom;
          margin-right: 7px;
        }

        span {
          span {
            color: ${theme.color.red};
          }
        }
      }

      & > button {
        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        &.openInfo {
          position: absolute;
          top: 10px;
          right: 15px;
        }

        &.foldInfo {
          position: absolute;
          top: 5px;
          right: 15px;
          transform: rotate(180deg);
        }
      }

      .contents {
        padding: 15px 0 0;
        width: 98%;
        font-size: 12px;

        p {
          font-weight: 500;
          line-height: 18px;

          .marker {
            color: ${theme.color.red};

            span {
              margin-left: 7px;
            }
          }

          .bulletPoint {
            margin-left: 10px;

            &::before {
              content: '';
              display: inline-block;
              width: 3px;
              height: 3px;
              border-radius: 50%;
              margin: 0 5px 3px 0;
              background-color: #000000;
            }

            &.marker {
              &::before {
                background-color: ${theme.color.red};
              }
            }

            br + strong,
            br + .marker {
              margin-left: 20px;
            }
          }
        }

        button {
          width: 100%;
          margin: 20px 0 5px;
          height: 36px;
          font-size: 12px;
          text-align: center;
          font-weight: 700;
          border: 1px solid #dcdce4;
          border-radius: 5px;
        }
      }

      .moreInfo {
        position: absolute;
        top: 9px;
        right: 12px;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
      }
    }
  }
`;
